module.exports = __webpack_public_path__ + "img/6.969c6ad0.png";